export default __webpack_public_path__ + "static/media/contactIcon.ac3259e3.png";